module.exports = __webpack_public_path__ + "static/work59-f695c3820c2f558509fd19a426f99826.jpg";